import { Suspense, lazy } from 'react';
import type { SlotEntry } from '@saas/ui';

/**
 * 画面の差し込み口（`@saas/ui` の Slot）に crm が出すもの。登録は apps/web/src/app/slots.ts（組み立て）だけが行う。
 *
 * | id | スロット | subjectType | 出すもの |
 * |---|---|---|---|
 * | crm.customer-leads | record.panel | customer / contact | この会社（人）からの問い合わせ・見込み客（§5.9 逆引き）|
 * | crm.shared-emails | record.panel | customer / contact / lead / deal | 共有メール（SFA 1B・§6.3。押すと本文ドロワー）|
 * | crm.marketing-consent | record.panel | lead / contact | 配信同意・停止の状態と履歴（SFA 段階 5 §9.6。記録は応答の canManage のとき）|
 *
 * 見込み客の read（own / team / all のどれか）が無い人には逆引きを出さない。共有メールは crm.email.read が無い人には出さない。
 * 部品は 0 件・403・404 なら null を返す
 */
const CustomerLeadsPanel = lazy(() => import('./components/leads/CustomerLeadsPanel.js'));
const SharedEmailPanel = lazy(() => import('./components/email/SharedEmailPanel.js'));
const ConsentPanel = lazy(() => import('./components/consent/ConsentPanel.js'));

export const crmSlots: SlotEntry[] = [
  {
    id: 'crm.customer-leads',
    module: 'crm',
    slot: 'record.panel',
    subjectTypes: ['customer', 'contact'],
    permission: ['crm.lead.read.own', 'crm.lead.read.team', 'crm.lead.read.all'],
    order: 30,
    Component: (props) => (
      <Suspense fallback={null}>
        <CustomerLeadsPanel {...props} />
      </Suspense>
    ),
  },
  {
    // 関連先の画面の「共有メール」。一覧はサーバが「関連先を読める ∩ 共有範囲」で絞る（別の関連先から開いても同じ判定）
    id: 'crm.shared-emails',
    module: 'crm',
    slot: 'record.panel',
    subjectTypes: ['customer', 'contact', 'lead', 'deal'],
    permission: ['crm.email.read'],
    order: 35,
    Component: (props) => (
      <Suspense fallback={null}>
        <SharedEmailPanel {...props} />
      </Suspense>
    ),
  },
  {
    // 一斉メールの配信同意（台帳は crm）。読めない・対象外なら部品が null を返す
    id: 'crm.marketing-consent',
    module: 'crm',
    slot: 'record.panel',
    subjectTypes: ['lead', 'contact'],
    permission: ['crm.lead.read.own', 'crm.lead.read.team', 'crm.lead.read.all', 'crm.contact.read.own', 'crm.contact.read.team', 'crm.contact.read.all'],
    order: 40,
    Component: (props) => (
      <Suspense fallback={null}>
        <ConsentPanel {...props} />
      </Suspense>
    ),
  },
];
